













import { Component, Prop, Vue } from "vue-property-decorator";
// components
import FileManager from "@/components/files/FileManager.vue";
// service methods
import { getFolder } from "@/services/files/fileService";
// types
import { MediaType, VscFile } from "@/services/files/types";

@Component({
    components: {
        FileManager
    }
})
export default class FileSelectModal extends Vue {
    @Prop() types!: MediaType[];
    @Prop({ default: "modal-fileSelect" }) id!: string;

    // Data properties
    selectedFile = {} as VscFile;
    folderId = "";
    fileId = "";

    // methods
    open(fileId: string = "") {
        this.folderId = "";
        this.fileId = "";
        if (fileId !== "") {
            getFolder(fileId).then(response => {
                if (response !== "") {
                    this.fileId = fileId;
                    this.folderId = response;
                }
                this.$bvModal.show(this.id);
            });
        } else {
            this.$bvModal.show(this.id);
        }
    }

    fileSelected(file: VscFile) {
        this.selectedFile = file;
    }

    select() {
        if (Object.keys(this.selectedFile).length > 0) {
            this.$emit("select", { fileId: this.selectedFile.id, name: this.selectedFile.name, mediaType: this.selectedFile.mediaType });
            this.selectedFile = {} as VscFile; // reset selected file
        }
    }

    close() {
        this.folderId = "";
        this.fileId = "";
        this.$bvModal.hide(this.id);
    }
}
